import { withRouter } from "react-router-dom";
import RMSRebalanceAlertStore from "./RMSRebalanceAlertStore";
import RMSRebalanceAlertContainer from "./RMSRebalanceAlertContainer";

export default withRouter(RMSRebalanceAlertStore(RMSRebalanceAlertContainer));
